import { createUseStyles, Styles } from 'react-jss';

export default createUseStyles((theme: Styles) => ({
  body: {
    padding: '10px 0 0',
    width: '50%'
  }
}));
